export default __webpack_public_path__ + "static/media/iconFacebook.100906d1.svg";